import { CustomCellRendererProps } from "@ag-grid-community/react";
import {Link} from "@mui/material";

const EmailRenderer = (params: CustomCellRendererProps) => (
  <Link href={`mailto:${params.value}`}>{params.value}</Link>
)

export default EmailRenderer;
